module.exports = __webpack_public_path__ + "src/assets/img/leftArrow.4ee9c1d9bbb959ee2770fac2f8000a46.svg";